import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const IssueIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 13V13.023M12 7.5V10M6 4H18C19.105 4 20 4.895 20 6V15C20 16.105 19.105 17 18 17H13.554C13.191 17 12.836 17.099 12.525 17.285L8 20V17H6C4.895 17 4 16.105 4 15V6C4 4.895 4.895 4 6 4Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

IssueIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(IssueIcon);
